import React from 'react';
import { styled } from '@mui/material/styles';
import { KitGridContainer, KitGridItem } from 'components/common/cms-kit';

const BannerContainer = styled('div')((props) => ({
  width: 'auto',
  flexGrow: 1,
  flexShrink: 0,
  padding: '1.5rem 0',
  margin: '15px 25px 10px 10px',
  [props.theme.breakpoints.up('md')]: {
    margin: '15px 25px 5px 30px',
    backgroundRepeat: props.repeat ? 'repeat' : 'no-repeat',
    backgroundPosition: props.repeat ? 'top left' : 'center top',
    backgroundAttachment: 'fixed',
    backgroundColor: 'transparent',
    backgroundImage: `url(${props.bgurl})`,
  },
}));

const BannerContentContainer = styled('div')(({ theme }) => ({
  '@media screen and (min-width: 1408px)': {
    maxWidth: '1344px',
  },
  '@media screen and (min-width: 1216px)': {
    maxWidth: '1152px',
  },
  '@media screen and (min-width: 1024px)': {
    maxWidth: '960px',
  },
  flexGrow: 1,
  margin: '0 auto',
  position: 'relative',
  width: 'auto',
}));

const BannerContent = styled('div')({
  width: 'auto',
  alignItems: 'center',
});

const BannerMain = styled('div')(({ theme }) => ({
  '@media screen and (min-width: 769px)': {
    flex: 'none',
    width: '98%',
    display: 'block',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1,
    paddingTop: '0.75rem',
  },
}));

const BannerLinks = styled('div')(({ theme }) => ({
  '@media screen and (min-width: 769px)': {
    flex: 'none',
    width: '58.33333%',
  },
  display: 'block',
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
  padding: '0.75rem',
}));

const Text = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  [theme.breakpoints.up('lg')]: {
    width: '98%',
  },
  [theme.breakpoints.down('md')]: {
    width: '98%',
  },
}));

const Title = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: 'transparent',
  fontSize: '28px',
  lineHeight: '32px',
  [theme.breakpoints.up('lg')]: {
    width: '98%',
  },
  [theme.breakpoints.down('md')]: {
    width: '98%',
  },
}));

const SubTitle = styled('div')(({ theme }) => ({
  color: theme.palette.primary.light,
  backgroundColor: 'transparent',
  marginTop: '5px',
  fontSize: '18px',
  lineHeight: '20px',
  [theme.breakpoints.up('lg')]: {
    width: '98%',
  },
  [theme.breakpoints.down('md')]: {
    width: '98%',
  },
}));

const Banner = (props) => {
  const { title, subTitle, backgroundImage, showLinks } = props.module.fields;

  return (
    <BannerContainer
      bgurl={backgroundImage?.url}
      repeat={backgroundImage && backgroundImage?.width < 600}
    >
      <KitGridContainer
        direction="row"
        align="center"
        style={{
          marginLeft: '5px',
          width: '98%',
          border: '2px solid transparent',
        }}
      >
        <KitGridItem xs={12} sm={10} md={9} lg={8} align="left">
          <BannerContentContainer>
            <BannerContent>
              <BannerMain>
                <Text>
                  <Title>{title}</Title>
                </Text>
                {subTitle && <SubTitle secondary>{subTitle}</SubTitle>}
              </BannerMain>
              <BannerLinks>{showLinks && <></>}</BannerLinks>
            </BannerContent>
          </BannerContentContainer>
        </KitGridItem>
      </KitGridContainer>
    </BannerContainer>
  );
};
export default Banner;
